import React from 'react'
import Layout from '../components/Layout'
function Resume() {
    return (
        <Layout>
            <section className='resumeSec'>
                <h3>RESUME</h3>
                <h2>EXPERIENCE</h2>

                <div className='timelineWrapper'>
                    <ul className="timeline">
                    <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2023 - present</span>
                                <h5>EY</h5>
                                <h4>Sr FrontEnd Developer</h4>
                                <p>
                                Created and maintained high-quality, streamlined, and scalable code.
                                Collaborated with designers and project managers to develop user
                                interfaces.

                                </p>
                            </div>
                        </li>
                        <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2020 - 2023</span>
                                <h5>The Collective</h5>
                                <h4>FrontEnd Developer</h4>
                                <p>
                                    Pixel perfect Animated web development with advanced javascript, css libraries.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2019 - 2020</span>
                                <h5>Centric</h5>
                                <h4>FrontEnd Developer</h4>
                                <p>Full Stack Front-end Developer! My responsibilities are creating web and mobile application using
                                    bootstrap 4 ,html,css3, javascript, react-native and other libraries to create a best user friendly design.
                                </p>
                            </div>
                        </li>
                        <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2018 - 2019</span>
                                <h5>HashSystemic</h5>
                                <h4>FrontEnd Developer</h4>
                                <p>As a Front-end Developer my responsibilities are creating applications using reactjs, <br />
                                    bootstrap,html,css, javascript and other libraries to create a best user friendly design.</p>
                            </div>
                        </li>
                       
                    </ul>
                </div>


                <h3>RESUME</h3>
                <h2>EDUCATION</h2>
                <div className='timelineWrapper'>
                    <ul className="timeline">
                        <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2014 - 2020</span>
                                <h5>UNIVERSITY</h5>
                                <h4>Graduation In Computer Science at PAF-KIET</h4>
                                <p>Computer scientists design and analyze algorithms to solve programs and study the performance of computer hardware and software.

                                </p></div>
                        </li>
                        <li>
                            <div className="mirza-timeline-content"><span className="mirza-timeline-date">2012 - 2014</span>
                                <h5>COLLEGE</h5>
                                <h4>Studied Pre-Engineering at Saleem Nawaz Fazaia Masroor Base</h4>
                                <p>At its heart engineering is about using science to find creative practical solutions. It’s a noble profession.</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </Layout>
    )
}

export default Resume